/**
 * The requests a client component may make.
 *
 * This module used to exist because the browser *could not* reach the admin
 * API: `ADMIN_API_BASE_URL` was server-only, so a direct call fell back to a
 * hardcoded localhost that was right only by luck, and the admin API sent no
 * CORS headers so the browser would have blocked it anyway. Everything here
 * therefore went to this app by relative path and a route handler forwarded it.
 *
 * Both reasons are gone. The UI is a static bundle with no server to forward
 * with, the base URL is a build-time public value, and the admin service sends
 * CORS headers for the origin serving this bundle. So this is now a thin
 * adapter over the ordinary API client, kept only because `RecordList` reads
 * its `RecordPage` shape.
 */

import { listRecords } from "@/lib/api/client";
import type { MasterRecord } from "@/lib/api/types";

export type RecordPage = { rows: MasterRecord[]; total: number };

/** One page of a master's records. Throws with the server's message on failure. */
export async function fetchRecords(
  sport: string,
  master: string,
  query: { q?: string; filter?: string[]; limit?: number; offset?: number } = {},
  fetchImpl: typeof fetch = fetch,
): Promise<RecordPage> {
  const page = await listRecords(sport, master, query, fetchImpl);
  return { rows: page.rows, total: page.total };
}
